interface CyodCategory {
  categoryName: string;
  requirements: string[];
}

interface GroupData {
  coupon: number;
  timespan?: number;
  cyodProducts: number[];
  requirements: CyodCategory[];
}

interface Groups {
  [groupName: string]: GroupData;
}

// Mock data representing groups and their CYOD products
const mockGroupsData: Groups = {
  IT: {
    coupon: 300,
    cyodProducts: [6429, 6397, 4854, 6594, 6166, 6366, 6264],
    requirements: [
      {
        categoryName: 'Smartphone',
        requirements: ['Beschermhoesje', 'Beschermglas'],
      },
    ],
  },
  Sales: {
    coupon: 250,
    cyodProducts: [6429, 6397, 6396],
    requirements: [
      {
        categoryName: 'Smartphone',
        requirements: ['Beschermhoesje', 'Beschermglas'],
      },
    ],
  },
  // Add more groups here as needed
};

// Service for managing CYOD products for groups
const groupService = {
  // Function to get CYOD products for a specific group
  getCYODProductsForGroup: (groupName: string): number[] => {
    return mockGroupsData[groupName]
      ? mockGroupsData[groupName].cyodProducts
      : [];
  },

  // Function to get requirements for a specific group
  getRequirements: (groupName: string): CyodCategory[] => {
    return mockGroupsData[groupName]
      ? mockGroupsData[groupName].requirements
      : [];
  },

  // TODO: Coupon per user, only usable once
  // Function to get coupon for a specific group
  getCoupon: (groupName: string): number => {
    return mockGroupsData[groupName] ? mockGroupsData[groupName].coupon : 0;
  },

  // Function to get coupon for a specific group
  setCoupon: (groupName: string, amount: number): number => {
    return (mockGroupsData[groupName].coupon -= amount);
  },

  // Function to add a CYOD product to a group
  addCYODProductToGroup: (groupName: string, productId: number): void => {
    if (!mockGroupsData[groupName]) {
      mockGroupsData[groupName] = { cyodProducts: [productId] };
    } else {
      mockGroupsData[groupName].cyodProducts.push(productId);
    }
  },

  // Function to remove a CYOD product from a group
  removeCYODProductFromGroup: (groupName: string, productId: number): void => {
    if (mockGroupsData[groupName]) {
      mockGroupsData[groupName].cyodProducts = mockGroupsData[
        groupName
      ].cyodProducts.filter((id) => id !== productId);
    }
  },

  // Function to clear all CYOD products from a group
  clearCYODProductsFromGroup: (groupName: string): void => {
    if (mockGroupsData[groupName]) {
      mockGroupsData[groupName].cyodProducts = [];
    }
  },
};

export default groupService;
